import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import PageLayout from '@/components/Layout/PageLayout';
import { usePermissions } from '@/contexts/auth';
import { ALL_DAYPART_TAGS, DEFAULT_DAYPART_TAG } from '@/contexts/cage-filter-context';
import { OVERVIEW_WEIGHT_UNIT_TAG } from '@/domain/cages';

import { useCageOverview } from '../../../components/cage-overview-context';

import CageWelfareFishSpeedView from './CageWelfareFishSpeedView';

export default function CageWelfareFishSpeedContainer() {
    const { t } = useTranslation();
    const { dateFrom, dateTo, onDateChange, data, error, loading, isFetching, refetch } =
        useCageOverview();
    const { isOptoScaleAdmin } = usePermissions();

    // Admins see every daypart; everyone else only the default one.
    const graphedDaypartTags = useMemo<string[]>(
        () => (isOptoScaleAdmin ? [...ALL_DAYPART_TAGS] : [DEFAULT_DAYPART_TAG]),
        [isOptoScaleAdmin]
    );

    /**
     * Only the default daypart starts visible, regardless of the page filter — the
     * legacy chart hardcoded this too, so switching the filter does not change which
     * swim-speed series is shown up front.
     */
    const activeDaypartTags = useMemo<string[]>(() => [DEFAULT_DAYPART_TAG], []);

    return (
        <PageLayout title={t('cageWelfare.fishspeed.fishSpeed')}>
            <CageWelfareFishSpeedView
                days={data.behaviour.days}
                graphedDaypartTags={graphedDaypartTags}
                activeDaypartTags={activeDaypartTags}
                daypartTag={DEFAULT_DAYPART_TAG}
                weightUnitTag={OVERVIEW_WEIGHT_UNIT_TAG}
                isLoading={loading}
                error={error}
                retry={{ onRetry: refetch, isRetrying: isFetching }}
                dateFrom={dateFrom}
                dateTo={dateTo}
                onDateChange={onDateChange}
            />
        </PageLayout>
    );
}
